export const API_MANAGER_KEY = process.env.REACT_APP_MANAGER_KEY
export const GTM_KEY = process.env.REACT_APP_GTM_KEY
export const UNSPLASH_ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;